import React from "react"
import Link from "next/link"
import { useMainEnterpriseId } from "../../hooks/enterprise"
import { useShopId } from "../../hooks/shop"
import { useShopSalePointId } from "../../hooks/shopSalePoint"

export default function NavMainMenu() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()
  const shopSalePointId = useShopSalePointId()

  return (
    <>
      <Link
        href={`/e/${enterpriseId}/${shopId}/${shopSalePointId}/sales`}
        className="inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
      >
        Новая продажа
      </Link>

      <div className="relative my-4">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-300" />
        </div>
      </div>

      <Link
        href={`/e/${enterpriseId}/${shopId}/${shopSalePointId}/orders`}
        className="my-2 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
      >
        Кассовые ордера
      </Link>

      <Link
        href={`/e/${enterpriseId}/${shopId}/${shopSalePointId}/revision`}
        className="my-2 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none"
      >
        Ревизия
      </Link>

      {/*<button*/}
      {/*  type="button"*/}
      {/*  className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"*/}
      {/*>*/}
      {/*  Отчёт за день*/}
      {/*</button>*/}

      {/*<button*/}
      {/*  type="button"*/}
      {/*  className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"*/}
      {/*>*/}
      {/*  Ревизия {isRevisionStarted ? '(Продолжить ревизию)' : ''}*/}
      {/*</button>*/}

      {/*<div className="relative my-4">*/}
      {/*  <div className="absolute inset-0 flex items-center" aria-hidden="true">*/}
      {/*    <div className="w-full border-t border-gray-300"/>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*<Link*/}
      {/*  href={"/"}*/}
      {/*  className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"*/}
      {/*>*/}
      {/*  Назад*/}
      {/*</Link>*/}
    </>
  )
}
